class t{constructor(t){this._code=t,Object.freeze(this)}static _fromValue(e){return new t(e)}toString(){return this._code.toString()}valueOf(){return this._code}}export{t as default};
//# sourceMappingURL=HttpStatus.js.map
